import * as React from 'react';
import { useMemo, } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import {LinearProgress} from '@mui/material';
import { baseAtom} from '../../stores/jotai/base';
import MaterialArtifactEditor from '../app/material-artifact-editor';
import { hasPermissionInterviewWrite } from '../../stores/jotai/permissions';
import { ARTIFACT_TYPES } from '../../constants';
import { artifactAtom } from '../../stores/jotai/artifacts/artifacts';

export default function MaterialNoteEditor(props:any) {
    const { interviewData, disableDefaultBorder }=props;
    const [artifacts, ] = useAtom(artifactAtom);
    const base = useAtomValue(baseAtom);
    const selectedInterviewID = base?.selectedInterview;
    const note = artifacts?.note ? artifacts?.note?.[selectedInterviewID] : {};
    const selectedInterview = interviewData?.find(
        (interview) => interview?.interviewID === selectedInterviewID
    );

    const templateID = selectedInterview?.templateID;

    let memoizedEditor = useMemo(() => {
        return (
            <MaterialArtifactEditor
                isReadOnly={
                    !hasPermissionInterviewWrite(base, base.selectedInterview, artifacts)
                }
                artifactID={note?.artifactID}
                templateID={templateID}
                artifactType={ARTIFACT_TYPES.INTERVIEW_NOTE}
                useToolBar={true}
                disableDefaultBorder={disableDefaultBorder}
            />
        );
    }, [note?.artifactID])

    if (note === null || note === undefined) {
        return <LinearProgress />;
    }

    return memoizedEditor;
}